import { useMutation } from '@tanstack/react-query';
import { updateResponseAction } from '@/api/endpoints';
import { queryKeys } from '@/api/queryKeys';
import type { UpdateResponseActionRequest } from '@/types/api.types';

export interface WorkspaceResponseActionVariables {
  responseId: string;
  request: UpdateResponseActionRequest;
}

/**
 * Mutation for persisting a reviewer's Accept / Edit / Reject decision against
 * a single response, via the existing
 * `PATCH /v1/insight/sessions/{id}/responses/{rid}` endpoint.
 *
 * Self-contained for the workspace module: it does not touch the review
 * feature's session store, so the panel can be tested and mounted in
 * isolation. The caller owns local optimistic state (the index panel updates
 * its own question list on success, and is responsible for rolling that
 * overlay back via the per-call `onError` callback when a PATCH fails).
 */
export function useWorkspaceResponseAction(sessionId: string) {
  return useMutation({
    mutationKey: queryKeys.workspaceResponseAction(sessionId),
    mutationFn: ({ responseId, request }: WorkspaceResponseActionVariables) =>
      updateResponseAction(sessionId, responseId, request),
  });
}
